import useLoginPageProps from "../selectors/useLoginPageProps";
import LoginPageView from "../components/loginPage";

export default function LoginPage() {
	const viewProps = useLoginPageProps();
	return LoginPageView(viewProps);
}
